import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useCategoryContext } from '../../CategoryProvider';
import { Arrow } from '../../../../../Common/Icon';
import { SubCategoryRow } from './SubCategoryRow';
import CategoryStatistics from '..';
import ModalFullScreen from '../../../../../Common/ModalFullScreen';

import styles from './index.module.scss';

const ModalCategoryDetails = () => {
  const { clearSelectedCategoryAndSubCategory, category, subCategory } =
    useCategoryContext();

  if (!category) {
    return null;
  }

  const subCategories = useMemo(() => {
    const currentIndex = subCategory
      ? category.subCategories.indexOf(subCategory)
      : 0;

    const firstArray = category.subCategories.slice(0, currentIndex + 1);
    const secondArray = category.subCategories.slice(currentIndex + 1);

    return {
      firstArray,
      secondArray,
    };
  }, [category, subCategory]);

  return (
    <ModalFullScreen
      isOpen={!!category}
      onCancel={clearSelectedCategoryAndSubCategory}
    >
      <div className={styles.header}>
        <Link to={`/categories/${category.id}`} className={styles.viewCategory}>
          View Category{' '}
          <Arrow
            className={styles.icon}
            width={24}
            height={24}
            viewBox="0 0 24 24"
          />
        </Link>

        {category.subCategories.length ? (
          <div className={styles.theadWrapper}>
            <div className={styles.thead}>Customer Avg:</div>
            <div className={styles.thead}>Worker Avg:</div>
          </div>
        ) : null}
      </div>
      {category.subCategories.length ? (
        <div>
          {subCategories.firstArray.map((item) => (
            <SubCategoryRow
              key={item.id}
              subCategory={item}
              categoryId={category.id}
            />
          ))}
          <div className={styles.statisticsWrapper}>
            <CategoryStatistics />
          </div>
          {subCategories.secondArray.map((item) => (
            <SubCategoryRow
              key={item.id}
              subCategory={item}
              categoryId={category.id}
            />
          ))}
        </div>
      ) : null}
    </ModalFullScreen>
  );
};

export default ModalCategoryDetails;
